module.exports = __webpack_public_path__ + "static/media/root_beer_stamp_fr.7f40fbe9.svg";